import * as React from 'react'
import { StickyStatus, type Offset } from './types'
import * as supports from '@owl-nest/feature-detection'
import {
  useDramaticallyInefficientScopedCss,
  css,
  useDramaticallyInefficientGlobalCss,
} from '@owl-nest/yak/extra-runtime'

type StickyContextConfig = {
  sticky?: (status: StickyStatus) => string
  fallbackToSticky?: boolean
}

type StickyContextProps = {
  $status: StickyStatus
  $offset?: Offset
}

export function stickyContext(
  selector: string,
  { sticky, fallbackToSticky = false }: StickyContextConfig,
): React.FunctionComponent<React.JSX.IntrinsicElements['div'] & StickyContextProps> {
  return StickyContext

  function StickyContext({
    $status,
    $offset = { top: 0 },
    className,
    ...props
  }: React.JSX.IntrinsicElements['div'] & StickyContextProps) {
    const stickyBaseClassName = useDramaticallyInefficientScopedCss(css`
      position: relative;
    `)

    useDramaticallyInefficientGlobalCss(css`
      .${stickyBaseClassName} .${selector} {
        ${fallbackToSticky && supports.positionSticky()
          ? css`
              position: sticky;
              ${$offset.top !== undefined &&
              css`
                top: ${$offset.top}px;
              `}
              ${$offset.bottom !== undefined &&
              css`
                bottom: ${$offset.bottom}px;
              `}
              background-color: #fff;
            `
          : sticky && sticky($status)}
      }
    `)

    return <div {...props} className={[className, stickyBaseClassName].filter(Boolean).join(' ')} />
  }
}
